import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-69" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-70" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-71" data-mp="129h0hmovcycw">
          <span className="text-blush" data-id="element-72" data-mp="sb1cvtp1w785">SANİYELER İÇİNDE</span> <span className="text-grape" data-id="element-73" data-mp="s9qanyb977j5">PROFESYONEL</span> RAPORLAR OLUŞTURUN
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-74" data-mp="nbf0tnkykx0x">
          Vardiya sonu evrak yükünü azaltmak için tasarlanmış kapsamlı yapay zekâ komutları ve profesyonel raporlama çerçeveleri
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-75" data-mp="3j9agpbwlmo4m">
          <img src="https://cdn.magicpatterns.com/uploads/sHdrgebaHzrKAKvcTtfBPn/Kit_Sigma_Smart_de_Reportes_Tacticos.webp" alt="100+ Taktik Rapor Yapay Zekâ Komutu™ — 6 Ciltlik Görsel Sistem + 4 Profesyonel Bonus" width={1536} height={1024} sizes="(min-width: 640px) 600px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[600px] object-contain" data-id="element-76" data-mp="3e7uwtn65qnnt" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-77" data-mp="2vgu0z80c388h">
          100+ TAKTİK RAPOR YAPAY ZEKÂ KOMUTU™ — 6 Ciltlik Görsel Sistem + 4 Profesyonel Bonus · SIGMA SMART™ Yöntemi · ⭐ 4,9/5 (500'den fazla yetkili memnun kaldı) · ⚡ Anında erişim
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-78" data-mp="s3cmudv0pps5">
          <CTAButton href="#pricing" data-id="element-79" data-mp="nb1jf112jluu">Tüm sistemi görüntüle</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-80" data-mp="ic889f9986xu">
            <span className="font-bold text-plum" data-id="element-81" data-mp="i9vpizvo9sjq">2026 İÇİN GELİŞTİRİLEN PROFESYONEL YAPAY ZEKÂ DESTEKLİ RAPORLAMA SİSTEMİ.</span> 2026'nın 1 numaralı yapay zeka komuta sistemi. Devriye memurları, dedektifler, amirler ve kesin, hukuken sağlam ve hızlı belgelendirmeye ihtiyaç duyan kolluk kuvveti profesyonelleri için tasarlandı.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-82" data-mp="111y8wizp7mxo">
            Olay raporları · Olay yeri ve delil belgeleri · Müdahale kayıtları · Kriz yönetimi · İstihbarat analizleri · İdari raporlar
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-83" data-mp="3lqm1dvdxqztc">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-84" data-mp="1xa44lgt9woko">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-85" data-mp="26a999j7318v5" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-86" data-mp="2b0zcaps1czmo">
            - İhtiyacınız olan raporlama kaynakları tek bir dijital koleksiyonda -
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-87" data-mp="2kynbpt0l6vb6">
          🔥 Sınırlı süreli teklif · Fiyat kısa süre içinde 2.660 TRY'ye dönecek
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-88" data-mp="2tx7okdjguarh">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-89" data-mp="uou0t33o7k89" />
          12 görevli bu taktiksel seti inceliyor.
        </p>
      </div>
    </header>;
}